import ApplicationLogout from './ApplicationLogout';

const ApplicationLogoutAPI = async (setLogoutStatus, logoutUser, dispatch, navigate) => {
  try {
    const res = await logoutUser({}).unwrap();
    setLogoutStatus && setLogoutStatus(res?.message);
    ApplicationLogout(dispatch, navigate);
  } catch (error) {
    // console.log(error);
  }
};

export default ApplicationLogoutAPI;
